import { render, staticRenderFns } from "./transformationTable.vue?vue&type=template&id=e8691708&scoped=true&"
import script from "./transformationTable.vue?vue&type=script&lang=js&"
export * from "./transformationTable.vue?vue&type=script&lang=js&"
import style0 from "./transformationTable.vue?vue&type=style&index=0&id=e8691708&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8691708",
  null
  
)

export default component.exports